(function () {
    const DEFAULT_MAX_PER_PRODUCT = 100;

    const productMaxQty = {
      P001: 60,
      P002: 60,
      P003: 60,
      P004: 60,
      P005: 60,
      P006: 60,
      P007: 60,
      P008: 60,
      P009: 60,
      P010: 60,
      P011: 60,
      P012: 60,
      P013: 60,
      P014: 60,
      P015: 60,
      P016: 60,
      P017: 60,
      P018: 60,
      N1001: 60,
      N1002: 60,
      N1003: 60,
      N1004: 60,
      N1005: 60,
      N1006: 60,
      N1007: 60,
      N1008: 60,
      N1009: 60,
      N1010: 60,
      N1011: 60,
      N1012: 60,
      N1013: 60,
      N1014: 60,
      N1015: 60,
      N1016: 60,
      N1017: 60,
      N1018: 60,
      N1019: 60,
      N1020: 60,
      N1021: 60,
      N1022: 60,
      N1023: 60,
      N1024: 60,
      N1025: 60,
      N1026: 60,
      N1027: 60,
      N1028: 60,
      N1029: 60,
      N1030: 60,
      N1031: 60,
      N1032: 60,
      N1033: 60,
      N1034: 60,
      N1035: 60,
      N1036: 60,
      N1037: 60,
      N1038: 60,
      N1039: 60,
      N1040: 60,
      N1041: 60,
      N1042: 60,
      N1043: 60,
      N1044: 60,
      N1045: 60,
      N1046: 60,
      N1047: 60,
      N1048: 60,
      N1049: 60,
      N1050: 60,
      N1051: 60,
      N1052: 60,
      N1053: 60,
      N1054: 60,
      N1055: 60,
      N1056: 60,
      N1057: 60,
      N1058: 60,
      N1059: 60,
      N1060: 60,
      N1061: 60,
      N1062: 60,
      N1063: 60,
      N1064: 60,
      N1065: 60,
      N1066: 60,
      N1067: 60,
      N1068: 60,
      N1069: 60,
      N1070: 60,
      N1071: 60,
      N1072: 60,
      N1073: 60,
      N1074: 60,
      N1075: 60,
      N1076: 60,
      N1077: 60,
      N1078: 60,
      N1079: 60,
      N1080: 60,
      N1081: 60,
      N1082: 60,
      N1083: 60,
      N1084: 60,
      N1085: 60,
      N1086: 60,
      N1087: 60,
      N1088: 60,
      N1089: 60,
      N1090: 60,
      N1091: 60,
      N1092: 60,
      N2001: 60,
      N2002: 60,
      N2003: 60,
      N2004: 60,
      N2005: 60,
      N2006: 60,
      N2007: 60,
      N2008: 60,
      N2009: 60,
      N2010: 60,
      N2011: 60,
      N2012: 60,
      N2013: 60,
      N2014: 60,
      N2015: 60,
      N2016: 60,
      N2017: 60,
      N2018: 60,
      N2019: 60,
      N2020: 60,
      N2021: 60,
      N2022: 60,
      N2023: 60,
      N2024: 60,
      N2025: 60,
      N2026: 60,
      N2027: 60,
      N2028: 60,
      N2029: 60,
      N2030: 60,
      N2031: 60,
      N2032: 60,
      N2033: 60,
      N2034: 60,
      N2035: 60,
      N2036: 60,
      N2037: 60,
      N2038: 60,
      N2039: 60,
      N2040: 60,
      N2041: 60,
      N2042: 60,
      N2043: 60,
      N2044: 60,
      N2045: 60,
      N2046: 60,
      N2047: 60,
      N2048: 60,
      N2049: 60,
      N2050: 60,
      N2051: 60,
      N2052: 60,
      N2053: 60,
      N2054: 60,
      N2055: 60,
      N2056: 60,
      N2057: 60,
      N2058: 60,
      N2059: 60,
      N2060: 60,
      N2061: 60,
      N2062: 60,
      N2063: 60,
      N2064: 60,
      N2065: 60,
      N2066: 60,
      N2067: 60,
      N3001: 60,
      N3002: 60,
      N3003: 60,
      N3004: 60,
      N3005: 60,
      N3006: 60,
      N3007: 60,
      N3008: 60,
      N3009: 60,
      N3010: 60,
      N3011: 60,
      N3012: 60,
      N3013: 60,
      N3014: 60,
      N3015: 60,
      N3016: 60,
      N3017: 60,
      N3018: 60,
      N3019: 60,
      N3020: 60,
      N3021: 60,
      N3022: 60
    };

    const productVideoUrls = {
      P001: "",
      P002: "",
      P003: "",
      P004: "",
      P005: "",
      P006: "",
      P007: "",
      P008: "",
      P009: "",
      P010: "",
      P011: "",
      P012: "",
      P013: "",
      P014: "",
      P015: "",
      P016: "",
      P017: "",
      P018: "",
      N1001: "",
      N1002: "",
      N1003: "",
      N1004: "",
      N1005: "",
      N1006: "",
      N1007: "",
      N1008: "",
      N1009: "",
      N1010: "",
      N1011: "",
      N1012: "",
      N1013: "",
      N1014: "",
      N1015: "",
      N1016: "",
      N1017: "",
      N1018: "",
      N1019: "",
      N1020: "",
      N1021: "",
      N1022: "",
      N1023: "",
      N1024: "",
      N1025: "",
      N1026: "",
      N1027: "",
      N1028: "",
      N1029: "",
      N1030: "",
      N1031: "",
      N1032: "",
      N1033: "",
      N1034: "",
      N1035: "",
      N1036: "",
      N1037: "",
      N1038: "",
      N1039: "",
      N1040: "",
      N1041: "",
      N1042: "",
      N1043: "",
      N1044: "",
      N1045: "",
      N1046: "",
      N1047: "",
      N1048: "",
      N1049: "",
      N1050: "",
      N1051: "",
      N1052: "",
      N1053: "",
      N1054: "",
      N1055: "",
      N1056: "",
      N1057: "",
      N1058: "",
      N1059: "",
      N1060: "",
      N1061: "",
      N1062: "",
      N1063: "",
      N1064: "",
      N1065: "",
      N1066: "",
      N1067: "",
      N1068: "",
      N1069: "",
      N1070: "",
      N1071: "",
      N1072: "",
      N1073: "",
      N1074: "",
      N1075: "",
      N1076: "",
      N1077: "",
      N1078: "",
      N1079: "",
      N1080: "",
      N1081: "",
      N1082: "",
      N1083: "",
      N1084: "",
      N1085: "",
      N1086: "",
      N1087: "",
      N1088: "",
      N1089: "",
      N1090: "",
      N1091: "",
      N1092: "",
      N2001: "",
      N2002: "",
      N2003: "",
      N2004: "",
      N2005: "",
      N2006: "",
      N2007: "",
      N2008: "",
      N2009: "",
      N2010: "",
      N2011: "",
      N2012: "",
      N2013: "",
      N2014: "",
      N2015: "",
      N2016: "",
      N2017: "",
      N2018: "",
      N2019: "",
      N2020: "",
      N2021: "",
      N2022: "",
      N2023: "",
      N2024: "",
      N2025: "",
      N2026: "",
      N2027: "",
      N2028: "",
      N2029: "",
      N2030: "",
      N2031: "",
      N2032: "",
      N2033: "",
      N2034: "",
      N2035: "",
      N2036: "",
      N2037: "",
      N2038: "",
      N2039: "",
      N2040: "",
      N2041: "",
      N2042: "",
      N2043: "",
      N2044: "",
      N2045: "",
      N2046: "",
      N2047: "",
      N2048: "",
      N2049: "",
      N2050: "",
      N2051: "",
      N2052: "",
      N2053: "",
      N2054: "",
      N2055: "",
      N2056: "",
      N2057: "",
      N2058: "",
      N2059: "",
      N2060: "",
      N2061: "",
      N2062: "",
      N2063: "",
      N2064: "",
      N2065: "",
      N2066: "",
      N2067: "",
      N3001: "",
      N3002: "",
      N3003: "",
      N3004: "",
      N3005: "",
      N3006: "",
      N3007: "",
      N3008: "",
      N3009: "",
      N3010: "",
      N3011: "",
      N3012: "",
      N3013: "",
      N3014: "",
      N3015: "",
      N3016: "",
      N3017: "",
      N3018: "",
      N3019: "",
      N3020: "",
      N3021: "",
      N3022: ""
    };

    const products = [
      { id: 1, code: "P001", name: "Premium Athletic Mix", weight: 100, price: 500, tags: ["premium"], qty: 0 },
      { id: 2, code: "P002", name: "Premium Athletic Winter", weight: 100, price: 450, tags: ["premium"], qty: 0 },
      { id: 3, code: "P003", name: "Premium Children Mix", weight: 100, price: 500, tags: ["premium","children"], qty: 0 },
      { id: 4, code: "P004", name: "Premium Children Winter Mix", weight: 100, price: 300, tags: ["premium","children"], qty: 0 },
      { id: 5, code: "P005", name: "Premium HHR (Casa Mixta)", weight: 100, price: 200, tags: ["premium","household"], qty: 0 },
      { id: 6, code: "P006", name: "Premium Ladies Oversize Mix", weight: 100, price: 250, tags: ["premium","women"], qty: 0 },
      { id: 7, code: "P007", name: "Premium Men Oversize", weight: 100, price: 250, tags: ["premium","men"], qty: 0 },
      { id: 8, code: "P008", name: "Premium Oversize Winter", weight: 100, price: 150, tags: ["premium"], qty: 0 },
      { id: 9, code: "P009", name: "Premium Swim Suit", weight: 100, price: 400, tags: ["premium"], qty: 0 },
      { id: 10, code: "P010", name: "Boutique Winter Mix", weight: 100, price: 350, tags: ["premium"], qty: 0 },
      { id: 11, code: "P011", name: "Texas Boutique", weight: 100, price: 500, tags: ["premium"], qty: 0 },
      { id: 12, code: "P012", name: "Mixta Summer Premium Juvenil", weight: 100, price: 350, tags: ["premium"], qty: 0 },
      { id: 13, code: "P013", name: "Premium Brand Mix", weight: 100, price: 500, tags: ["premium"], qty: 0 },
      { id: 14, code: "P014", name: "Premium Men Mix", weight: 100, price: 550, tags: ["premium","men"], qty: 0 },
      { id: 15, code: "P015", name: "Premium Brassier", weight: 100, price: 700, tags: ["premium","women"], qty: 0 },
      { id: 16, code: "P016", name: "Premium Lenceria Mix", weight: 100, price: 500, tags: ["premium","women"], qty: 0 },
      { id: 17, code: "P017", name: "Premium Oversize Mix", weight: 100, price: 250, tags: ["premium"], qty: 0 },
      { id: 18, code: "P018", name: "TGT Traje de Baño Nuevo", weight: 100, price: 600, tags: ["premium"], qty: 0 },
      { id: 19, code: "N1001", name: "Athletic Winter #1", weight: 100, price: 275, tags: ["number1"], qty: 0 },
      { id: 20, code: "N1002", name: "Athletic Joggers* #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 21, code: "N1003", name: "Athletic Mix Shorts * #1", weight: 100, price: 250, tags: ["number1"], qty: 0 },
      { id: 22, code: "N1004", name: "Athletic Mix T-Shirt* #1", weight: 100, price: 225, tags: ["number1"], qty: 0 },
      { id: 23, code: "N1005", name: "Athletic T-Shirt L/S* #1", weight: 100, price: 180, tags: ["number1"], qty: 0 },
      { id: 24, code: "N1006", name: "Bedsheet #1", weight: 100, price: 160, tags: ["number1","household"], qty: 0 },
      { id: 25, code: "N1007", name: "Blanket #1", weight: 100, price: 100, tags: ["number1","household"], qty: 0 },
      { id: 26, code: "N1008", name: "Blusa De Oficina #1", weight: 100, price: 200, tags: ["number1","women"], qty: 0 },
      { id: 27, code: "N1009", name: "Bra* #1", weight: 100, price: 275, tags: ["number1","women"], qty: 0 },
      { id: 28, code: "N1010", name: "Brand Jacket Mix* #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 29, code: "N1011", name: "Brand Sweater Mix* #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 30, code: "N1012", name: "Brand Western Jeans* #1", weight: 100, price: 250, tags: ["number1"], qty: 0 },
      { id: 31, code: "N1013", name: "Children Denim Jeans #1", weight: 100, price: 250, tags: ["number1","children"], qty: 0 },
      { id: 32, code: "N1014", name: "Children Mix 0-16 #1", weight: 100, price: 250, tags: ["number1","children"], qty: 0 },
      { id: 33, code: "N1015", name: "Children Mix Jacket #1", weight: 100, price: 250, tags: ["number1","children"], qty: 0 },
      { id: 34, code: "N1016", name: "Children Mix T-Shirt #1", weight: 100, price: 180, tags: ["number1","children"], qty: 0 },
      { id: 35, code: "N1017", name: "Children Winter Mix #1", weight: 100, price: 150, tags: ["number1","children"], qty: 0 },
      { id: 36, code: "N1018", name: "Christmas Mix Sweater* #1", weight: 100, price: 150, tags: ["number1"], qty: 0 },
      { id: 37, code: "N1019", name: "Comfort #1", weight: 100, price: 120, tags: ["number1"], qty: 0 },
      { id: 38, code: "N1020", name: "Costumes* #1", weight: 100, price: 150, tags: ["number1"], qty: 0 },
      { id: 39, code: "N1021", name: "Curtain #1", weight: 100, price: 140, tags: ["number1","household"], qty: 0 },
      { id: 40, code: "N1022", name: "Flannel Jacket* #1", weight: 100, price: 120, tags: ["number1"], qty: 0 },
      { id: 41, code: "N1023", name: "Fleece Mix Jacket* #1", weight: 100, price: 120, tags: ["number1"], qty: 0 },
      { id: 42, code: "N1024", name: "HHR (Casa Mixta) #1", weight: 100, price: 150, tags: ["number1","household"], qty: 0 },
      { id: 43, code: "N1025", name: "Hoodie Sweat Shirt #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 44, code: "N1026", name: "Jacket Mix* #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 45, code: "N1027", name: "Jogger Pants * #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 46, code: "N1028", name: "Jumper Mix #1", weight: 100, price: 275, tags: ["number1"], qty: 0 },
      { id: 47, code: "N1029", name: "Ladies Capri* #1", weight: 100, price: 45, tags: ["number1","women"], qty: 0 },
      { id: 48, code: "N1030", name: "Ladies Cardigans* #1", weight: 100, price: 70, tags: ["number1","women"], qty: 0 },
      { id: 49, code: "N1031", name: "Ladies Jeans #1", weight: 100, price: 180, tags: ["number1","women"], qty: 0 },
      { id: 50, code: "N1032", name: "Ladies Dress Pant #1", weight: 100, price: 150, tags: ["number1","women"], qty: 0 },
      { id: 51, code: "N1033", name: "Ladies Flannel Blouse* #1", weight: 100, price: 125, tags: ["number1","women"], qty: 0 },
      { id: 52, code: "N1034", name: "Ladies Leggings #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 53, code: "N1035", name: "Lenceria Mix #1", weight: 100, price: 300, tags: ["number1","women"], qty: 0 },
      { id: 54, code: "N1036", name: "Ladies Mix Blouse #1", weight: 100, price: 275, tags: ["number1","women"], qty: 0 },
      { id: 55, code: "N1037", name: "Ladies Mix Dress #1", weight: 100, price: 275, tags: ["number1","women"], qty: 0 },
      { id: 56, code: "N1038", name: "Ladies Mix Skirt #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 57, code: "N1039", name: "Ladies Mix T-Shirt #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 58, code: "N1040", name: "Ladies Oversize Blouse #1", weight: 100, price: 100, tags: ["number1","women"], qty: 0 },
      { id: 59, code: "N1041", name: "Ladies Oversize Capri* #1", weight: 100, price: 45, tags: ["number1","women"], qty: 0 },
      { id: 60, code: "N1042", name: "Ladies Oversize Denim Jeans #1", weight: 100, price: 150, tags: ["number1","women"], qty: 0 },
      { id: 61, code: "N1043", name: "Ladies Oversize Dress #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 62, code: "N1044", name: "Ladies Oversize Pants #1", weight: 100, price: 100, tags: ["number1","women"], qty: 0 },
      { id: 63, code: "N1045", name: "Ladies Oversize Skirt* #1", weight: 100, price: 150, tags: ["number1","women"], qty: 0 },
      { id: 64, code: "N1046", name: "Ladies Oversize Sweater* #1", weight: 100, price: 50, tags: ["number1","women"], qty: 0 },
      { id: 65, code: "N1047", name: "Ladies Oversize Swim Suit #1", weight: 100, price: 120, tags: ["number1","women"], qty: 0 },
      { id: 66, code: "N1048", name: "Ladies Panties* #1", weight: 100, price: 400, tags: ["number1","women"], qty: 0 },
      { id: 67, code: "N1049", name: "Ladies Party Dress #1", weight: 100, price: 275, tags: ["number1","women"], qty: 0 },
      { id: 68, code: "N1050", name: "Ladies Rayon Pants #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 69, code: "N1051", name: "Ladies Skinny Jeans #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 70, code: "N1052", name: "Ladies Sport Bra* #1", weight: 100, price: 250, tags: ["number1","women"], qty: 0 },
      { id: 71, code: "N1053", name: "Ladies Sweater Dress* #1", weight: 100, price: 120, tags: ["number1","women"], qty: 0 },
      { id: 72, code: "N1054", name: "Ladies Sweater* #1", weight: 100, price: 120, tags: ["number1","women"], qty: 0 },
      { id: 73, code: "N1055", name: "Ladies Swim Suit* #1", weight: 100, price: 150, tags: ["number1","women"], qty: 0 },
      { id: 74, code: "N1056", name: "Ladies T-Shirt L/S #1", weight: 100, price: 80, tags: ["number1","women"], qty: 0 },
      { id: 75, code: "N1057", name: "Leather Jacket* #1", weight: 100, price: 150, tags: ["number1"], qty: 0 },
      { id: 76, code: "N1058", name: "Mats & Rugs #1", weight: 100, price: 120, tags: ["number1","household"], qty: 0 },
      { id: 77, code: "N1059", name: "Medical Uniform #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 78, code: "N1060", name: "Men Boxer* #1", weight: 100, price: 275, tags: ["number1","men"], qty: 0 },
      { id: 79, code: "N1061", name: "Men Cargo Pants* #1", weight: 100, price: 250, tags: ["number1","men"], qty: 0 },
      { id: 80, code: "N1062", name: "Men Denim Jeans #1", weight: 100, price: 350, tags: ["number1","men"], qty: 0 },
      { id: 81, code: "N1063", name: "Men Dress Pant #1", weight: 100, price: 150, tags: ["number1","men"], qty: 0 },
      { id: 82, code: "N1064", name: "Men Hawaiian Shirt* #1", weight: 100, price: 250, tags: ["number1","men"], qty: 0 },
      { id: 83, code: "N1065", name: "Men Mix Shirt #1", weight: 100, price: 180, tags: ["number1","men"], qty: 0 },
      { id: 84, code: "N1066", name: "Men Oversize Denim Jeans * #1", weight: 100, price: 250, tags: ["number1","men"], qty: 0 },
      { id: 85, code: "N1067", name: "Men Oversize Shirt #1", weight: 100, price: 150, tags: ["number1","men"], qty: 0 },
      { id: 86, code: "N1068", name: "Men Ovesize Dress Pants * #1", weight: 100, price: 100, tags: ["number1","men"], qty: 0 },
      { id: 87, code: "N1069", name: "Men Sweater* #1", weight: 100, price: 120, tags: ["number1","men"], qty: 0 },
      { id: 88, code: "N1070", name: "Men T-Shirt #1", weight: 100, price: 200, tags: ["number1","men"], qty: 0 },
      { id: 89, code: "N1071", name: "Men T-Shirt L/S #1", weight: 100, price: 150, tags: ["number1","men"], qty: 0 },
      { id: 90, code: "N1072", name: "New Levis 60 pcs #1", weight: 100, price: 585, tags: ["number1"], qty: 0 },
      { id: 91, code: "N1073", name: "Oversize Pajama* #1", weight: 100, price: 60, tags: ["number1"], qty: 0 },
      { id: 92, code: "N1074", name: "Oversize Shorts* #1", weight: 100, price: 250, tags: ["number1"], qty: 0 },
      { id: 93, code: "N1075", name: "Oversize Sweat Mix* #1", weight: 100, price: 60, tags: ["number1"], qty: 0 },
      { id: 94, code: "N1076", name: "Oversize Sweater Mix * #1", weight: 100, price: 60, tags: ["number1"], qty: 0 },
      { id: 95, code: "N1077", name: "Pet Accessories* #1", weight: 100, price: 200, tags: ["number1","household"], qty: 0 },
      { id: 96, code: "N1078", name: "Pillow Case #1", weight: 100, price: 60, tags: ["number1","household"], qty: 0 },
      { id: 97, code: "N1079", name: "Sexy Short #1", weight: 100, price: 140, tags: ["number1"], qty: 0 },
      { id: 98, code: "N1080", name: "Ski Jacket* #1", weight: 100, price: 250, tags: ["number1"], qty: 0 },
      { id: 99, code: "N1081", name: "Ski Pants* #1", weight: 100, price: 100, tags: ["number1"], qty: 0 },
      { id: 100, code: "N1082", name: "Ski Vest* #1", weight: 100, price: 140, tags: ["number1"], qty: 0 },
      { id: 101, code: "N1083", name: "Socks #1", weight: 100, price: 100, tags: ["number1"], qty: 0 },
      { id: 102, code: "N1084", name: "Sweatpant Joggers* #1", weight: 100, price: 200, tags: ["number1"], qty: 0 },
      { id: 103, code: "N1085", name: "Sweatshirt Mix #1", weight: 100, price: 120, tags: ["number1"], qty: 0 },
      { id: 104, code: "N1086", name: "Table Cloth #1", weight: 100, price: 120, tags: ["number1","household"], qty: 0 },
      { id: 105, code: "N1087", name: "Faja Talladora #1", weight: 100, price: 350, tags: ["number1"], qty: 0 },
      { id: 106, code: "N1088", name: "Wool Coats* #1", weight: 100, price: 120, tags: ["number1"], qty: 0 },
      { id: 107, code: "N1089", name: "Blusa Fancy Juvenil #1", weight: 100, price: 285, tags: ["number1","women"], qty: 0 },
      { id: 108, code: "N1090", name: "Blusa Crop Top #1", weight: 100, price: 300, tags: ["number1","women"], qty: 0 },
      { id: 109, code: "N1091", name: "Short Cargo #1", weight: 100, price: 275, tags: ["number1"], qty: 0 },
      { id: 110, code: "N1092", name: "Winter Light Plus Size #1", weight: 100, price: 50, tags: ["number1"], qty: 0 },
      { id: 111, code: "N2001", name: "Children Mix 0-16 #2", weight: 100, price: 170, tags: ["number2","children"], qty: 0 },
      { id: 112, code: "N2002", name: "Adult Mix (Amarillo) #2", weight: 100, price: 85, tags: ["number2"], qty: 0 },
      { id: 113, code: "N2003", name: "Athletic Mix T-Shirt #2", weight: 100, price: 180, tags: ["number2"], qty: 0 },
      { id: 114, code: "N2004", name: "Athletic T-Shirt L/S #2", weight: 100, price: 150, tags: ["number2"], qty: 0 },
      { id: 115, code: "N2005", name: "Athletic Winter Mix #2", weight: 100, price: 180, tags: ["number2"], qty: 0 },
      { id: 116, code: "N2006", name: "Baby Accessories #2", weight: 100, price: 70, tags: ["number2","children"], qty: 0 },
      { id: 117, code: "N2007", name: "Baby Blanket * #2", weight: 100, price: 100, tags: ["number2","children","household"], qty: 0 },
      { id: 118, code: "N2008", name: "Bedsheet #2", weight: 100, price: 95, tags: ["number2","household"], qty: 0 },
      { id: 119, code: "N2009", name: "Blusa De Oficina #2", weight: 100, price: 95, tags: ["number2","women"], qty: 0 },
      { id: 120, code: "N2010", name: "Brand Denim Jeans #2", weight: 100, price: 250, tags: ["number2"], qty: 0 },
      { id: 121, code: "N2011", name: "Brand Mix Juvenil #2", weight: 100, price: 275, tags: ["number2"], qty: 0 },
      { id: 122, code: "N2012", name: "Brand Pants #2", weight: 100, price: 250, tags: ["number2"], qty: 0 },
      { id: 123, code: "N2013", name: "Brand Sweat Mix #2", weight: 100, price: 250, tags: ["number2"], qty: 0 },
      { id: 124, code: "N2014", name: "Brand T-Shirt mix #2", weight: 100, price: 250, tags: ["number2"], qty: 0 },
      { id: 125, code: "N2015", name: "Children Winter Mix #2", weight: 100, price: 100, tags: ["number2","children"], qty: 0 },
      { id: 126, code: "N2016", name: "Comfort #2", weight: 100, price: 85, tags: ["number2"], qty: 0 },
      { id: 127, code: "N2017", name: "Flannel Bed Sheet #2", weight: 100, price: 120, tags: ["number2","household"], qty: 0 },
      { id: 128, code: "N2018", name: "HHR #2", weight: 100, price: 120, tags: ["number2","household"], qty: 0 },
      { id: 129, code: "N2019", name: "Hoodie Sweat Shirt #2", weight: 100, price: 120, tags: ["number2"], qty: 0 },
      { id: 130, code: "N2020", name: "Jacket Mix #2", weight: 100, price: 150, tags: ["number2"], qty: 0 },
      { id: 131, code: "N2021", name: "Ladies Blazer #2", weight: 100, price: 60, tags: ["number2","women"], qty: 0 },
      { id: 132, code: "N2022", name: "Ladies Capri #2", weight: 100, price: 30, tags: ["number2","women"], qty: 0 },
      { id: 133, code: "N2023", name: "Ladies Jeans #2", weight: 100, price: 150, tags: ["number2","women"], qty: 0 },
      { id: 134, code: "N2024", name: "Ladies Dress Pant #2", weight: 100, price: 120, tags: ["number2","women"], qty: 0 },
      { id: 135, code: "N2025", name: "Ladies Flannel Blouse #2", weight: 100, price: 100, tags: ["number2","women"], qty: 0 },
      { id: 136, code: "N2026", name: "Ladies Legging #2", weight: 100, price: 85, tags: ["number2","women"], qty: 0 },
      { id: 137, code: "N2027", name: "Lenceria Mix #2", weight: 100, price: 120, tags: ["number2","women"], qty: 0 },
      { id: 138, code: "N2028", name: "Blusa Fancy Juvenil #2", weight: 100, price: 140, tags: ["number2","women"], qty: 0 },
      { id: 139, code: "N2029", name: "Ladies Mix Blouse #2", weight: 100, price: 140, tags: ["number2","women"], qty: 0 },
      { id: 140, code: "N2030", name: "Ladies Mix Dress #2", weight: 100, price: 140, tags: ["number2","women"], qty: 0 },
      { id: 141, code: "N2031", name: "Ladies Mix Skirt #2", weight: 100, price: 140, tags: ["number2","women"], qty: 0 },
      { id: 142, code: "N2032", name: "Ladies Mix T-Shirt #2", weight: 100, price: 75, tags: ["number2","women"], qty: 0 },
      { id: 143, code: "N2033", name: "Ladies Oversize Blouse #2", weight: 100, price: 75, tags: ["number2","women"], qty: 0 },
      { id: 144, code: "N2034", name: "Ladies Oversize Denim #2", weight: 100, price: 100, tags: ["number2","women"], qty: 0 },
      { id: 145, code: "N2035", name: "Ladies Oversize Dress #2", weight: 100, price: 100, tags: ["number2","women"], qty: 0 },
      { id: 146, code: "N2036", name: "Ladies Oversize Skirt #2", weight: 100, price: 100, tags: ["number2","women"], qty: 0 },
      { id: 147, code: "N2037", name: "Ladies Party Dress #2", weight: 100, price: 180, tags: ["number2","women"], qty: 0 },
      { id: 148, code: "N2038", name: "Ladies Skinny Jeans #2", weight: 100, price: 150, tags: ["number2","women"], qty: 0 },
      { id: 149, code: "N2039", name: "Ladies Sweater #2", weight: 100, price: 50, tags: ["number2","women"], qty: 0 },
      { id: 150, code: "N2040", name: "Ladies T-Shirt L/S #2", weight: 100, price: 40, tags: ["number2","women"], qty: 0 },
      { id: 151, code: "N2041", name: "Saco Mix #2", weight: 100, price: 60, tags: ["number2"], qty: 0 },
      { id: 152, code: "N2042", name: "Men Denim Jeans #2", weight: 100, price: 250, tags: ["number2","men"], qty: 0 },
      { id: 153, code: "N2043", name: "Men Dress Pant #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 154, code: "N2044", name: "Men Flannel Shirt #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 155, code: "N2045", name: "Men Levis/Wrangler Denim #2", weight: 100, price: 250, tags: ["number2","men"], qty: 0 },
      { id: 156, code: "N2046", name: "Men Mix #2", weight: 100, price: 350, tags: ["number2","men"], qty: 0 },
      { id: 157, code: "N2047", name: "Men Mix Shirt #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 158, code: "N2048", name: "Men Oversize Denim #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 159, code: "N2049", name: "Men Oversize Dress Pant #2", weight: 100, price: 35, tags: ["number2","men"], qty: 0 },
      { id: 160, code: "N2050", name: "Men Oversize Shirt #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 161, code: "N2051", name: "Men Oversize T-Shirt #2", weight: 100, price: 50, tags: ["number2","men"], qty: 0 },
      { id: 162, code: "N2052", name: "Men Oversize T-Shirt L/S #2", weight: 100, price: 50, tags: ["number2","men"], qty: 0 },
      { id: 163, code: "N2053", name: "Men T-Shirt #2", weight: 100, price: 85, tags: ["number2","men"], qty: 0 },
      { id: 164, code: "N2054", name: "Men T-Shirt L/S #2", weight: 100, price: 100, tags: ["number2","men"], qty: 0 },
      { id: 165, code: "N2055", name: "Oversize Jacket #2", weight: 100, price: 100, tags: ["number2"], qty: 0 },
      { id: 166, code: "N2056", name: "Pajama Mix #2", weight: 100, price: 85, tags: ["number2"], qty: 0 },
      { id: 167, code: "N2057", name: "Scarf #2", weight: 100, price: 25, tags: ["number2"], qty: 0 },
      { id: 168, code: "N2058", name: "Short Mix #2", weight: 100, price: 200, tags: ["number2"], qty: 0 },
      { id: 169, code: "N2059", name: "Socks #2", weight: 100, price: 50, tags: ["number2"], qty: 0 },
      { id: 170, code: "N2060", name: "SweatPant Mix #2", weight: 100, price: 60, tags: ["number2"], qty: 0 },
      { id: 171, code: "N2061", name: "SweatShirt Mix #2", weight: 100, price: 60, tags: ["number2"], qty: 0 },
      { id: 172, code: "N2062", name: "Towel #2", weight: 100, price: 180, tags: ["number2","household"], qty: 0 },
      { id: 173, code: "N2063", name: "Winter Mix #3 #2", weight: 100, price: 25, tags: ["number2"], qty: 0 },
      { id: 174, code: "N2064", name: "Mixta tropical Juvenil #2", weight: 100, price: 160, tags: ["number2"], qty: 0 },
      { id: 175, code: "N2065", name: "Mixta Plus Size #2", weight: 100, price: 85, tags: ["number2"], qty: 0 },
      { id: 176, code: "N2066", name: "Winter Plus Size Mix #2", weight: 100, price: 25, tags: ["number2"], qty: 0 },
      { id: 177, code: "N2067", name: "Traje de Baño #2", weight: 100, price: 125, tags: ["number2"], qty: 0 },
      { id: 178, code: "N3001", name: "Children Mix 0-16 #3", weight: 100, price: 75, tags: ["number3","children"], qty: 0 },
      { id: 179, code: "N3002", name: "Children Winter Mix #3", weight: 100, price: 45, tags: ["number3","children"], qty: 0 },
      { id: 180, code: "N3003", name: "Lenceria Mix #3", weight: 100, price: 40, tags: ["number3","women"], qty: 0 },
      { id: 181, code: "N3004", name: "Hoodie Sweatshirt #3", weight: 100, price: 60, tags: ["number3"], qty: 0 },
      { id: 182, code: "N3005", name: "Ladies Brand Jeans #3", weight: 100, price: 150, tags: ["number3","women"], qty: 0 },
      { id: 183, code: "N3006", name: "Ladies Dress Pant #3", weight: 100, price: 60, tags: ["number3","women"], qty: 0 },
      { id: 184, code: "N3007", name: "Ladies Mix Blouse #3", weight: 100, price: 60, tags: ["number3","women"], qty: 0 },
      { id: 185, code: "N3008", name: "Ladies Mix Dress #3", weight: 100, price: 60, tags: ["number3","women"], qty: 0 },
      { id: 186, code: "N3009", name: "Ladies Mix Skirt #3", weight: 100, price: 60, tags: ["number3","women"], qty: 0 },
      { id: 187, code: "N3010", name: "Men Mix Shirt #3", weight: 100, price: 60, tags: ["number3","men"], qty: 0 },
      { id: 188, code: "N3011", name: "Men Pant #3", weight: 100, price: 60, tags: ["number3","men"], qty: 0 },
      { id: 189, code: "N3012", name: "Short Mix #3", weight: 100, price: 85, tags: ["number3"], qty: 0 },
      { id: 190, code: "N3013", name: "Swim Suit #3", weight: 100, price: 60, tags: ["number3"], qty: 0 },
      { id: 191, code: "N3014", name: "Jean Regular #3", weight: 100, price: 100, tags: ["number3"], qty: 0 },
      { id: 192, code: "N3015", name: "Mix T-Shirt #3", weight: 100, price: 60, tags: ["number3"], qty: 0 },
      { id: 193, code: "N3016", name: "HHR (Casa Mixta) #3", weight: 100, price: 40, tags: ["number3","household"], qty: 0 },
      { id: 194, code: "N3017", name: "Mixta Plus Size #3", weight: 100, price: 60, tags: ["number3"], qty: 0 },
      { id: 195, code: "N3018", name: "Athletic Mix #3", weight: 100, price: 120, tags: ["number3"], qty: 0 },
      { id: 196, code: "N3019", name: "Ladies T-Shirt Mix #3", weight: 100, price: 50, tags: ["number3","women"], qty: 0 },
      { id: 197, code: "N3020", name: "T-Shirt Mix Plus Size #3", weight: 100, price: 40, tags: ["number3"], qty: 0 },
      { id: 198, code: "N3021", name: "Men T-Shirt Mix #3", weight: 100, price: 60, tags: ["number3","men"], qty: 0 },
      { id: 199, code: "N3022", name: "Blusa Mixta #3", weight: 100, price: 60, tags: ["number3","women"], qty: 0 }
    ];

    products.forEach(product => {
      product.maxQty = productMaxQty[product.code] || DEFAULT_MAX_PER_PRODUCT;
      product.videoUrl = productVideoUrls[product.code] || "";
    });

    let containerLimit = 250;
    let containerMin = 200;
    let containerLabel = "Contenedor de 20 pies";
    let activeCategory = "all";
    let activeSearch = "";

    // Detectar si hay agente autorizado logueado (4-digit code)
    let currentAgent = null;
    try {
      const stored = localStorage.getItem('mangys_agent');
      if (stored) currentAgent = JSON.parse(stored);
    } catch (e) { currentAgent = null; }

    const grid = document.getElementById("mangys-products-grid");
    const totalEl = document.getElementById("mangys-total");
    const limitEl = document.getElementById("mangys-limit");
    const containerTitleEl = document.getElementById("mangys-container-title");
    const orderListEl = document.getElementById("mangys-order-list");
    const orderCountEl = document.getElementById("mangys-order-count");
    const progressFillEl = document.getElementById("mangys-progress-fill");
    const statusEl = document.getElementById("mangys-status");
    const emailEl = document.getElementById("mangys-email");
    const phoneEl = document.getElementById("mangys-phone");
    const countryEl = document.getElementById("mangys-country");
    const nameEl = document.getElementById("mangys-fullname");
    const companyEl = document.getElementById("mangys-company");
    const quoteBtn = document.getElementById("mangys-quote-btn");
    const searchInput = document.getElementById("mangys-search");
    const overlay = document.getElementById("mangys-proforma-overlay");
    const pfItemsBody = document.getElementById("pf-items-body");
    const mobileTotalEl = document.getElementById("mangys-mobile-total");
    const mobileLimitEl = document.getElementById("mangys-mobile-limit");
    const mobileSummaryBtn = document.getElementById("mangys-mobile-summary-btn");
    const historyBtn = document.getElementById("mangys-history-btn");
    const historyOverlay = document.getElementById("mangys-history-overlay");
    const historyList = document.getElementById("mangys-history-list");
    const historyClose = document.getElementById("mangys-history-close");
    let lastScrollY = window.scrollY;
    let mobileBarManuallyHidden = false;
    const mobileBar = document.getElementById("mangys-mobile-summary-bar");
    const proformaDoc = document.getElementById("mangys-proforma-doc");
    const proformaStage = document.getElementById("mangys-proforma-stage");

    if (
      !grid || !totalEl || !limitEl || !containerTitleEl || !orderListEl || !orderCountEl ||
      !progressFillEl || !statusEl || !emailEl || !phoneEl || !countryEl || !nameEl ||
      !quoteBtn || !searchInput || !overlay || !pfItemsBody || !mobileTotalEl || !mobileSummaryBtn
    ) {
      return;
    }

    // ¿El cotizador está activo? Sí si hay cliente Shopify logueado O un agente.
    // Si no (mostrando el gate de login), no movemos la barra móvil al body para
    // que no aparezca flotando sobre la pantalla de login.
    const cotizadorActive = !!(window.MANGYS_CONFIG && window.MANGYS_CONFIG.customer) || !!currentAgent;

    // Mover la barra móvil y el overlay directamente al <body> para escapar de cualquier
    // ancestro con transform/filter/perspective que rompa el position:fixed (típico en
    // themes de Shopify con secciones animadas). Sin esto la barra "flota" a mitad de
    // pantalla en Chrome y otros navegadores.
    if (cotizadorActive && mobileBar && mobileBar.parentNode !== document.body) {
      document.body.appendChild(mobileBar);
    } else if (!cotizadorActive && mobileBar) {
      mobileBar.style.display = 'none';
    }
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    function formatUSD(value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    }

    function getTodayDate() {
      const d = new Date();
      return d.toLocaleDateString('en-US');
    }

    function getTotalQty() {
      return products.reduce((sum, p) => sum + p.qty, 0);
    }

    function remainingCapacity() {
      return Math.max(containerLimit - getTotalQty(), 0);
    }

    function canIncrease(product) {
      return product.qty < product.maxQty && getTotalQty() < containerLimit;
    }

    function renderProducts() {
      const filtered = products.filter(product => {
        const matchesCat = activeCategory === "all" || product.tags.includes(activeCategory);
        const matchesSearch = product.name.toLowerCase().includes(activeSearch.toLowerCase());
        return matchesCat && matchesSearch;
      });

      if (!filtered.length) {
        grid.innerHTML = `<div class="mangys-empty-order">No se encontraron productos.</div>`;
        return;
      }

      grid.innerHTML = filtered.map(product => {
        const plusDisabled = !canIncrease(product) ? "disabled" : "";
        const maxDisabled = !canIncrease(product) ? "disabled" : "";
        const selectedClass = product.qty > 0 ? "selected" : "";

        return `
          <div class="mangys-product-card ${selectedClass}">
            <h4 class="mangys-product-name">${product.name}</h4>
            <p class="mangys-product-meta">Peso: ${product.weight} lbs</p>
            ${product.videoUrl ? `<a href="${product.videoUrl}" target="_blank" rel="noopener" class="mangys-view-product-btn">Ver producto</a>` : `<button type="button" class="mangys-view-product-btn disabled" disabled>Ver producto</button>`}
            ${product.price ? `<p class="mangys-product-price" style="margin:10px 0 0;font-size:15px;font-weight:800;color:#245501;">$${product.price} <span style="font-weight:600;color:#4e772d;font-size:12px;letter-spacing:.04em;">USD / PACA</span></p>` : ""}

            <div class="mangys-counter">
              <button type="button" class="mangys-counter-btn" data-action="minus" data-id="${product.id}">−</button>
              <span class="mangys-qty">${product.qty}</span>
              <button type="button" class="mangys-counter-btn ${plusDisabled}" data-action="plus" data-id="${product.id}">+</button>
            </div>

            <div class="mangys-bottom-actions">
              <button type="button" class="mangys-max-btn min-btn" data-action="reset" data-id="${product.id}">MIN</button>
              <button type="button" class="mangys-max-btn ${maxDisabled}" data-action="max" data-id="${product.id}">MAX</button>
            </div>
          </div>
        `;
      }).join("");
    }

    function renderSummary() {
      const selectedProducts = products.filter(p => p.qty > 0);
      const total = getTotalQty();
      const percent = Math.min((total / containerLimit) * 100, 100);

      totalEl.textContent = total;
      mobileTotalEl.textContent = total;
      if (mobileLimitEl) mobileLimitEl.textContent = containerLimit;
      limitEl.textContent = containerLimit;
      containerTitleEl.textContent = containerLabel;
      progressFillEl.style.width = percent + "%";
      orderCountEl.textContent = selectedProducts.length;

      if (selectedProducts.length === 0) {
        orderListEl.innerHTML = `<div class="mangys-empty-order">No hay productos seleccionados</div>`;
        statusEl.textContent = "VACÍO";
        statusEl.className = "mangys-status";
      } else {
        orderListEl.innerHTML = selectedProducts.map(item => `
          <div class="mangys-order-item">
            <div class="mangys-order-left">
              <div class="mangys-order-qty">${item.qty} x</div>
              <div class="mangys-order-name">${item.name}</div>
            </div>
          </div>
        `).join("");

        if (total >= containerLimit) {
          statusEl.textContent = "LLENO (MÁXIMO)";
          statusEl.className = "mangys-status full";
        } else if (!currentAgent && total < containerMin) {
          statusEl.textContent = "FALTAN " + (containerMin - total) + " PACAS PARA EL MÍNIMO";
          statusEl.className = "mangys-status";
        } else {
          statusEl.textContent = "LISTO PARA COTIZAR";
          statusEl.className = "mangys-status ready";
        }
      }

      validateQuoteButton();
    }

    function validateQuoteButton() {
      const hasName = nameEl.value.trim() !== "";
      const hasCompany = companyEl ? companyEl.value.trim() !== "" : true;
      const hasEmail = emailEl.value.trim() !== "" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value.trim());
      const hasPhone = phoneEl.value.trim() !== "";
      const hasCountry = countryEl.value.trim() !== "";
      const total = getTotalQty();
      // Agentes autorizados: solo aplica el máximo (no el mínimo)
      // Clientes: aplican mínimo Y máximo del contenedor
      const effectiveMin = currentAgent ? 1 : containerMin;
      const hasProducts = total >= effectiveMin && total <= containerLimit;
      quoteBtn.disabled = !(hasName && hasCompany && hasEmail && hasPhone && hasCountry && hasProducts);
    }

    function updateAll() {
      renderProducts();
      renderSummary();
    }

    function setContainer(limit, label, min) {
      containerLimit = limit;
      containerMin = (typeof min === 'number' && !isNaN(min)) ? min : 0;
      containerLabel = label;

      const total = getTotalQty();
      if (total > containerLimit) {
        let overflow = total - containerLimit;

        for (let i = products.length - 1; i >= 0; i--) {
          if (overflow <= 0) break;
          if (products[i].qty > 0) {
            const reduceBy = Math.min(products[i].qty, overflow);
            products[i].qty -= reduceBy;
            overflow -= reduceBy;
          }
        }
      }

      updateAll();
    }

    function increaseProduct(id) {
      const product = products.find(p => p.id === id);
      if (!product || !canIncrease(product)) return;
      product.qty += 1;
      updateAll();
    }

    function decreaseProduct(id) {
      const product = products.find(p => p.id === id);
      if (!product || product.qty <= 0) return;
      product.qty -= 1;
      updateAll();
    }

    function resetProduct(id) {
      const product = products.find(p => p.id === id);
      if (!product) return;
      product.qty = 0;
      updateAll();
    }

    function maxProduct(id) {
      const product = products.find(p => p.id === id);
      if (!product) return;
      const room = remainingCapacity();
      if (room <= 0) return;
      const addable = Math.min(product.maxQty - product.qty, room);
      if (addable <= 0) return;
      product.qty += addable;
      updateAll();
    }

    function buildProforma() {
      const selectedProducts = products.filter(p => p.qty > 0);
      const totalBales = selectedProducts.reduce((sum, p) => sum + p.qty, 0);
      const totalWeight = selectedProducts.reduce((sum, p) => sum + (p.qty * p.weight), 0);
      const grandTotal = selectedProducts.reduce((sum, p) => sum + (p.qty * p.price), 0);

      document.getElementById("pf-client-name").textContent = nameEl.value.trim();
      const pfCompanyEl = document.getElementById("pf-client-company");
      if (pfCompanyEl) pfCompanyEl.textContent = (companyEl && companyEl.value.trim()) || '-';
      document.getElementById("pf-client-email").textContent = emailEl.value.trim();
      document.getElementById("pf-client-phone").textContent = phoneEl.value.trim();
      document.getElementById("pf-client-country").textContent = countryEl.value.trim();
      document.getElementById("pf-date").textContent = getTodayDate();
      document.getElementById("pf-container").textContent = containerLabel;
      document.getElementById("pf-total-bales").textContent = totalBales;
      document.getElementById("pf-total-bales-2").textContent = totalBales;
      document.getElementById("pf-total-weight").textContent = totalWeight + " lbs";
      document.getElementById("pf-total-weight-2").textContent = totalWeight + " lbs";
      document.getElementById("pf-grand-total").textContent = formatUSD(grandTotal);

      pfItemsBody.innerHTML = selectedProducts.map(item => {
        const lineTotal = item.qty * item.price;
        return `
          <tr>
            <td>${item.code}</td>
            <td>${item.name}</td>
            <td>${item.weight} lbs</td>
            <td>${item.qty}</td>
            <td>${formatUSD(item.price)}</td>
            <td>${formatUSD(lineTotal)}</td>
          </tr>
        `;
      }).join("");
    }

    document.querySelectorAll(".mangys-container-options .mangys-opcion").forEach(btn => {
      btn.addEventListener("click", function () {
        document.querySelectorAll(".mangys-container-options .mangys-opcion").forEach(b => b.classList.remove("active"));
        this.classList.add("active");
        const ft = this.getAttribute("data-container");
        const limit = parseInt(this.getAttribute("data-limit"), 10);
        const min = parseInt(this.getAttribute("data-min"), 10) || 0;
        setContainer(limit, "Contenedor de " + ft + " pies", min);
      });
    });

    document.getElementById("mangys-categorias").addEventListener("click", function (e) {
      const btn = e.target.closest(".cat-btn");
      if (!btn) return;
      document.querySelectorAll(".cat-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      activeCategory = btn.getAttribute("data-cat");
      renderProducts();
    });

    searchInput.addEventListener("input", function () {
      activeSearch = this.value.trim();
      renderProducts();
    });

    grid.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-action]");
      if (!btn || btn.classList.contains("disabled")) return;
      const action = btn.getAttribute("data-action");
      const id = parseInt(btn.getAttribute("data-id"), 10);
      if (action === "plus") increaseProduct(id);
      if (action === "minus") decreaseProduct(id);
      if (action === "reset") resetProduct(id);
      if (action === "max") maxProduct(id);
    });

    nameEl.addEventListener("input", validateQuoteButton);
    emailEl.addEventListener("input", validateQuoteButton);
    phoneEl.addEventListener("input", validateQuoteButton);
    countryEl.addEventListener("input", validateQuoteButton);
    if (companyEl) companyEl.addEventListener("input", validateQuoteButton);

    function isMobileView() {
      return window.matchMedia('(max-width: 700px)').matches;
    }

    function isIOSDevice() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
             (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }

    function base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      return new Blob(byteArrays, { type: mimeType });
    }

    let currentEditQuoteId = null;

    async function submitQuoteAndDownload(btnEl) {
      const cfg = window.MANGYS_CONFIG;
      if (!cfg || !cfg.apiUrl) {
        alert("La configuración no está cargada.");
        return;
      }

      const selectedProducts = products.filter(p => p.qty > 0);
      if (selectedProducts.length === 0) {
        alert("No has agregado productos a la cotización.");
        return;
      }

      const totalWeight = selectedProducts.reduce((s, p) => s + (p.qty * p.weight), 0);
      const grandTotal = selectedProducts.reduce((s, p) => s + (p.qty * p.price), 0);

      const originalText = btnEl ? btnEl.textContent : null;
      if (btnEl) {
        btnEl.disabled = true;
        btnEl.textContent = currentEditQuoteId ? "Actualizando cotización..." : "Generando cotización...";
      }

      const payload = {
        customer_name: nameEl.value.trim(),
        customer_company: companyEl ? companyEl.value.trim() : '',
        customer_email: emailEl.value.trim(),
        customer_phone: phoneEl.value.trim(),
        customer_country: countryEl.value.trim(),
        shopify_customer_id: (cfg.customer && cfg.customer.id) ? String(cfg.customer.id) : '',
        agent_code: (currentAgent && currentAgent.code) ? String(currentAgent.code) : '',
        container_label: containerLabel,
        container_limit: containerLimit,
        total_bales: getTotalQty(),
        total_weight: totalWeight,
        grand_total: grandTotal,
        items: selectedProducts.map(p => ({
          code: p.code, name: p.name, qty: p.qty, price: p.price, weight: p.weight
        }))
      };
      if (currentEditQuoteId) {
        payload.edit_quote_id = currentEditQuoteId;
      }

      try {
        const response = await fetch(cfg.apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.message || ("Status " + response.status));
        }

        const result = await response.json();

        if (result.airtable_error) {
          console.error("[Mangys] Airtable no pudo guardar:", result.airtable_error);
        }
        if (!result.pdf_base64) {
          throw new Error("No se recibió el PDF del servidor");
        }

        const pdfBlob = base64ToBlob(result.pdf_base64, "application/pdf");
        const filename = result.filename || "proforma.pdf";

        const iOS = isIOSDevice();
        let handled = false;

        if (iOS && navigator.canShare) {
          try {
            const file = new File([pdfBlob], filename, { type: "application/pdf" });
            if (navigator.canShare({ files: [file] })) {
              await navigator.share({ files: [file], title: "Proforma", text: filename });
              handled = true;
            }
          } catch (shareErr) {
            if (shareErr && shareErr.name === "AbortError") handled = true;
          }
        }

        if (!handled) {
          const blobUrl = URL.createObjectURL(pdfBlob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.rel = "noopener";
          a.style.display = "none";
          a.target = iOS ? "_blank" : "_self";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 30000);
        }

        console.log("[Mangys] Cotización OK:", result.quote_id);

        // Si era edit, salir del modo edit y limpiar el banner
        if (currentEditQuoteId) {
          currentEditQuoteId = null;
          const banner = document.getElementById('mangys-edit-banner');
          if (banner) banner.style.display = 'none';
          // Limpiar el query param sin recargar
          if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.delete('edit_quote_id');
            window.history.replaceState({}, '', url.toString());
          }
          quoteBtn.textContent = "Obtener cotización";
        }
      } catch (error) {
        console.error("[Mangys] Error:", error);
        const msg = (error && error.message) ? error.message : '';
        if (msg.indexOf('pendientes') !== -1 || msg.indexOf('Solo las cotizaciones') !== -1) {
          alert("Esta cotización ya no se puede editar (no está en estado Pendiente).");
        } else {
          alert("No se pudo generar la cotización. Por favor, inténtalo de nuevo.");
        }
      } finally {
        if (btnEl) {
          btnEl.disabled = false;
          btnEl.textContent = originalText;
        }
      }
    }

    async function loadQuoteForEdit(quoteId) {
      const cfg = window.MANGYS_CONFIG;
      if (!cfg || !cfg.customer || !cfg.customer.id) {
        alert("Necesitas iniciar sesión para editar una cotización.");
        return;
      }
      try {
        const url = cfg.apiUrl + '?customer_id=' + encodeURIComponent(cfg.customer.id);
        const resp = await fetch(url);
        const data = await resp.json();
        const quote = (data.quotes || []).find(function (q) { return q.id === quoteId; });
        if (!quote) {
          alert("No se encontró la cotización para editar.");
          return;
        }

        // Reset todas las cantidades
        products.forEach(function (p) { p.qty = 0; });

        // Setear contenedor (20 o 40 pies)
        const ftMatch = String(quote.container || '').match(/(\d+)\s*pies/i);
        const ft = ftMatch ? ftMatch[1] : '20';
        const containerBtn = document.querySelector('.mangys-container-options [data-container="' + ft + '"]');
        if (containerBtn) {
          document.querySelectorAll('.mangys-container-options .mangys-opcion').forEach(function (b) {
            b.classList.remove('active');
          });
          containerBtn.classList.add('active');
          const limit = parseInt(containerBtn.getAttribute('data-limit'), 10);
          const min = parseInt(containerBtn.getAttribute('data-min'), 10) || 0;
          containerLimit = limit;
          containerMin = min;
          containerLabel = 'Contenedor de ' + ft + ' pies';
        }

        // Aplicar cantidades de la cotización
        const items = Array.isArray(quote.items) ? quote.items : [];
        items.forEach(function (item) {
          const product = products.find(function (p) { return p.code === item.code; });
          if (product) {
            product.qty = Math.min(Number(item.qty) || 0, product.maxQty);
          }
        });

        // Prellenar form con los datos guardados en la cotización
        if (nameEl && quote.customer_name) nameEl.value = quote.customer_name;
        if (companyEl && quote.customer_company) companyEl.value = quote.customer_company;
        if (emailEl && quote.customer_email) emailEl.value = quote.customer_email;
        if (phoneEl && quote.customer_phone) phoneEl.value = quote.customer_phone;
        if (countryEl && quote.customer_country) countryEl.value = quote.customer_country;

        currentEditQuoteId = quote.id;
        quoteBtn.textContent = "Actualizar cotización";

        // Mostrar banner
        const banner = document.getElementById('mangys-edit-banner');
        if (banner) {
          const d = new Date(quote.created_at);
          const dateStr = isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-US', {
            year: 'numeric', month: 'short', day: 'numeric'
          });
          banner.innerHTML =
            '<strong>Editando cotización' + (dateStr ? ' del ' + dateStr : '') + '</strong>' +
            ' · Puedes cambiar cantidades o agregar productos. ' +
            '<a href="#" id="mangys-edit-cancel-link">Cancelar edición</a>';
          banner.style.display = 'block';

          const cancelLink = document.getElementById('mangys-edit-cancel-link');
          if (cancelLink) {
            cancelLink.addEventListener('click', function (e) {
              e.preventDefault();
              if (!confirm('¿Descartar los cambios y salir del modo edición?')) return;
              currentEditQuoteId = null;
              products.forEach(function (p) { p.qty = 0; });
              quoteBtn.textContent = "Obtener cotización";
              banner.style.display = 'none';
              if (window.history && window.history.replaceState) {
                const url = new URL(window.location.href);
                url.searchParams.delete('edit_quote_id');
                window.history.replaceState({}, '', url.toString());
              }
              updateAll();
            });
          }
        }

        updateAll();

        // Scroll arriba para que vea el banner
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        console.error('Error loading quote for edit:', err);
        alert("No pudimos cargar la cotización para editar.");
      }
    }

    // Si hay ?edit_quote_id=... en la URL, cargar la cotización para editar
    (function checkEditMode() {
      try {
        const params = new URLSearchParams(window.location.search);
        const editId = params.get('edit_quote_id');
        if (editId) {
          setTimeout(function () { loadQuoteForEdit(editId); }, 200);
        }
      } catch (e) { /* ignore */ }
    })();

    quoteBtn.addEventListener("click", async function () {
      await submitQuoteAndDownload(quoteBtn);
    });

    document.getElementById("mangys-close-proforma").addEventListener("click", function () {
      overlay.style.display = "none";
      document.body.style.overflow = "";
      updateAll();
    });

    document.getElementById("mangys-print-pdf").addEventListener("click", function () {
      window.print();
    });

    document.getElementById("mangys-download-pdf").addEventListener("click", async function () {
      await submitQuoteAndDownload(this);
    });

function goToMobileSummary(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const target = document.querySelector(".mangys-summary-box");
  if (!target || !mobileBar) return;

  mobileBar.classList.add("is-hidden");
  mobileBarManuallyHidden = true;

  const offset = 12;
  const targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: "smooth"
  });
}

mobileBar.addEventListener("click", goToMobileSummary);
mobileSummaryBtn.addEventListener("click", goToMobileSummary);

    window.addEventListener("scroll", function () {
      if (!mobileBar) return;
      const currentScrollY = window.scrollY;
      if (currentScrollY < lastScrollY - 20 && mobileBarManuallyHidden) {
        mobileBar.classList.remove("is-hidden");
        mobileBarManuallyHidden = false;
      }
      lastScrollY = currentScrollY;
    }, { passive: true });

    function fmtUSD(v) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(v) || 0);
    }

    function fmtDate(iso) {
      if (!iso) return '';
      try {
        return new Date(iso).toLocaleDateString('es-US', {
          year: 'numeric', month: 'short', day: 'numeric',
          hour: '2-digit', minute: '2-digit'
        });
      } catch (e) { return iso; }
    }

    let allQuotes = [];

    function renderHistoryList() {
      if (!historyList) return;
      const filterSel = document.getElementById('mangys-history-filter-status');
      const filterValue = filterSel ? filterSel.value : 'all';

      const filtered = filterValue === 'all'
        ? allQuotes
        : allQuotes.filter(function (q) {
            return (q.status || 'Pending') === filterValue;
          });

      if (!filtered.length) {
        historyList.innerHTML = filterValue === 'all'
          ? '<p class="mangys-history-empty">Aún no tienes cotizaciones guardadas.</p>'
          : '<p class="mangys-history-empty">No hay cotizaciones con ese filtro.</p>';
        return;
      }

      historyList.innerHTML = filtered.map(function (q) {
        const status = q.status || 'Pending';
        return '<div class="mangys-history-item" data-quote-id="' + q.id + '">' +
          '<h4>' +
            '<span>' + fmtDate(q.created_at) + '</span>' +
            '<span class="status" data-status="' + status + '">' + status + '</span>' +
          '</h4>' +
          '<div class="meta">' +
            '<span><strong>Contenedor:</strong><br>' + (q.container || '-') + '</span>' +
            '<span><strong>Pacas:</strong><br>' + (q.total_bales || 0) + '</span>' +
            '<span><strong>Total:</strong><br>' + fmtUSD(q.grand_total) + '</span>' +
          '</div>' +
          '<div class="mangys-history-item-cta">Ver detalle →</div>' +
        '</div>';
      }).join('');

      // Hacer cada item clickeable
      const items = historyList.querySelectorAll('.mangys-history-item');
      items.forEach(function (el) {
        el.addEventListener('click', function () {
          openQuoteDetail(el.getAttribute('data-quote-id'));
        });
      });
    }

    function openQuoteDetail(quoteId) {
      const quote = allQuotes.find(function (q) { return q.id === quoteId; });
      if (!quote) return;

      const overlay = document.getElementById('mangys-quote-detail-overlay');
      if (!overlay) return;

      const setText = function (id, val) {
        const el = document.getElementById(id);
        if (el) el.textContent = val;
      };

      setText('qd-date', fmtDate(quote.created_at));
      setText('qd-container', quote.container || '-');
      setText('qd-bales', String(quote.total_bales || 0));
      setText('qd-weight', (quote.total_weight || 0) + ' lbs');
      setText('qd-total', fmtUSD(quote.grand_total));

      const statusEl = document.getElementById('qd-status');
      if (statusEl) {
        const status = quote.status || 'Pending';
        statusEl.textContent = status;
        statusEl.setAttribute('data-status', status);
      }

      const itemsBody = document.getElementById('qd-items');
      if (itemsBody) {
        const items = Array.isArray(quote.items) ? quote.items : [];
        itemsBody.innerHTML = items.length
          ? items.map(function (item) {
              const lineTotal = (Number(item.qty) || 0) * (Number(item.price) || 0);
              return '<tr>' +
                '<td data-label="Código">' + (item.code || '') + '</td>' +
                '<td data-label="Descripción">' + (item.name || '') + '</td>' +
                '<td class="num" data-label="Cantidad">' + (item.qty || 0) + '</td>' +
                '<td class="num" data-label="Precio">' + fmtUSD(item.price) + '</td>' +
                '<td class="num" data-label="Total">' + fmtUSD(lineTotal) + '</td>' +
              '</tr>';
            }).join('')
          : '<tr><td colspan="5" style="text-align:center;padding:14px;color:#4e772d">Sin items</td></tr>';
      }

      // Botón "Editar" — disponible para cualquier status.
      // Al editar y guardar, el status vuelve automáticamente a Pending.
      const editBtn = document.getElementById('mangys-quote-edit-btn');
      if (editBtn) {
        editBtn.style.display = 'inline-block';
        editBtn.onclick = function () {
          const cotizadorUrl = window.location.pathname + '?edit_quote_id=' + encodeURIComponent(quoteId);
          window.location.href = cotizadorUrl;
        };
      }

      overlay.classList.add('is-open');
    }

    function normalizeStatus(s) {
      const lower = String(s || 'pending').toLowerCase().trim();
      if (lower.indexOf('cancel') === 0) return 'Cancelled';
      if (lower.indexOf('confirm') === 0) return 'Confirmed';
      return 'Pending';
    }

    async function loadHistory() {
      const cfg = window.MANGYS_CONFIG;
      if (!historyList) return;
      if (!cfg || !cfg.customer || !cfg.customer.id) {
        historyList.innerHTML = '<p class="mangys-history-empty">Inicia sesión para ver tu historial.</p>';
        return;
      }
      historyList.innerHTML = '<p class="mangys-history-empty">Cargando...</p>';
      try {
        const url = cfg.apiUrl + '?customer_id=' + encodeURIComponent(cfg.customer.id);
        const resp = await fetch(url);
        const data = await resp.json();
        allQuotes = (data.quotes || []).map(function (q) {
          return Object.assign({}, q, { status: normalizeStatus(q.status) });
        });
        renderHistoryList();
      } catch (err) {
        console.error(err);
        historyList.innerHTML = '<p class="mangys-history-empty">No pudimos cargar tu historial. Por favor, inténtalo de nuevo.</p>';
      }
    }

    // Filter de status
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'mangys-history-filter-status') {
        renderHistoryList();
      }
    });

    // Detail modal close handlers
    const quoteDetailOverlay = document.getElementById('mangys-quote-detail-overlay');
    const quoteDetailClose = document.getElementById('mangys-quote-detail-close');
    if (quoteDetailOverlay) {
      quoteDetailOverlay.addEventListener('click', function (e) {
        if (e.target === quoteDetailOverlay) quoteDetailOverlay.classList.remove('is-open');
      });
    }
    if (quoteDetailClose) {
      quoteDetailClose.addEventListener('click', function () {
        if (quoteDetailOverlay) quoteDetailOverlay.classList.remove('is-open');
      });
    }

    if (historyBtn) {
      const cfgHist = window.MANGYS_CONFIG;
      if (cfgHist && cfgHist.customer && cfgHist.customer.id) {
        historyBtn.style.display = 'block';
        historyBtn.addEventListener('click', function () {
          if (historyOverlay) historyOverlay.classList.add('is-open');
          loadHistory();
        });
        if (historyClose) {
          historyClose.addEventListener('click', function () {
            if (historyOverlay) historyOverlay.classList.remove('is-open');
          });
        }
        if (historyOverlay) {
          historyOverlay.addEventListener('click', function (e) {
            if (e.target === historyOverlay) historyOverlay.classList.remove('is-open');
          });
        }
      }
    }

    (function prefillFromCustomer() {
      const cfg = window.MANGYS_CONFIG;
      if (!cfg || !cfg.customer) return;
      const c = cfg.customer;
      if (c.firstName && c.lastName && !nameEl.value) {
        nameEl.value = (c.firstName + ' ' + c.lastName).trim();
      } else if (c.firstName && !nameEl.value) {
        nameEl.value = c.firstName;
      }
      if (c.email && !emailEl.value) {
        emailEl.value = c.email;
      }
      if (c.phone && phoneEl && !phoneEl.value) {
        phoneEl.value = c.phone;
      } else if (phoneEl && !phoneEl.value) {
        try {
          const pendingPhone = localStorage.getItem('mangys_pending_phone');
          if (pendingPhone) {
            phoneEl.value = pendingPhone;
            localStorage.removeItem('mangys_pending_phone');
          }
        } catch (e) {}
      }
      if (countryEl && !countryEl.value) {
        try {
          const pendingCountry = localStorage.getItem('mangys_pending_country');
          if (pendingCountry) {
            countryEl.value = pendingCountry;
            localStorage.removeItem('mangys_pending_country');
          }
        } catch (e) {}
      }
      if (companyEl && !companyEl.value) {
        try {
          const pendingCompany = localStorage.getItem('mangys_pending_company');
          if (pendingCompany) {
            companyEl.value = pendingCompany;
            // No removemos para que persista entre sesiones desde el mismo dispositivo
          }
        } catch (e) {}
      }
      validateQuoteButton();
    })();

    // ============ AGENT MODE: badge + logout ============
    (function setupAgentMode() {
      if (!currentAgent) return;

      // Mostrar el cotizador (estaba oculto) y esconder el gate de login
      const wrap = document.getElementById('mangys-cotizador-wrap');
      if (wrap) wrap.style.display = '';
      const gate = document.querySelector('.mangys-auth-gate');
      if (gate) gate.style.display = 'none';

      // Pre-llenar nombre del agente en el formulario si está vacío
      if (nameEl && !nameEl.value && currentAgent.name) {
        // No autocompletamos el nombre del cliente con el del agente,
        // el agente cotiza para clientes. Dejamos el form vacío.
      }

      // Crear badge arriba del cotizador (estilos inline para que no dependa
      // del CSS del liquid, que está scopeado al contenedor del cotizador).
      const badge = document.createElement('div');
      badge.setAttribute('style',
        'max-width:1400px;margin:18px auto 0;padding:0 18px;box-sizing:border-box;font-family:inherit;');
      badge.innerHTML =
        '<div style="background:linear-gradient(135deg,#245501,#143601);color:#fff;' +
          'border-radius:12px;padding:14px 20px;display:flex;align-items:center;gap:14px;' +
          'box-shadow:0 4px 14px rgba(20,54,1,.18);box-sizing:border-box;">' +
          '<span style="font-size:26px;line-height:1;flex:0 0 auto;">🛡️</span>' +
          '<div style="flex:1;display:flex;flex-direction:column;gap:2px;min-width:0;">' +
            '<strong style="font-size:11px;opacity:.85;text-transform:uppercase;' +
              'letter-spacing:.5px;font-weight:800;">Sesión de Agente Autorizado</strong>' +
            '<span style="font-size:17px;font-weight:800;line-height:1.2;">' + (currentAgent.name || '') + '</span>' +
          '</div>' +
          '<button type="button" id="mangys-agent-logout" style="flex:0 0 auto;' +
            'background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.35);' +
            'color:#fff;border-radius:8px;padding:9px 16px;font-size:13px;font-weight:700;' +
            'cursor:pointer;white-space:nowrap;font-family:inherit;">Cerrar sesión</button>' +
        '</div>';

      const cotizadorWrap = document.getElementById('mangys-cotizador-contenedor');
      if (cotizadorWrap && cotizadorWrap.parentNode) {
        cotizadorWrap.parentNode.insertBefore(badge, cotizadorWrap);
      } else {
        document.body.insertBefore(badge, document.body.firstChild);
      }

      const logoutBtn = document.getElementById('mangys-agent-logout');
      if (logoutBtn) {
        logoutBtn.addEventListener('click', function () {
          if (!confirm('¿Cerrar sesión de agente?')) return;
          try { localStorage.removeItem('mangys_agent'); } catch (e) {}
          window.location.reload();
        });
      }
    })();

    updateAll();
  })();

